import { Profile } from 'src/app/shared/entities/profile';
import { createGridDataFeature } from '../../shared/store/grid-data/create-grid-data-feature';
import { createDrilldownFeature } from '../../shared/store/drilldown/create-drilldown-feature';
import { createAction } from '@ngrx/store';
import { createEditItemFeature } from 'src/app/shared/store/edit-item/create-edit-item-feature';
import { UpdateProfileRequestDto } from 'src/app/shared/services/api/dto/update-profile-request-dto';
import { CreateCertificateProfileRequestDto } from 'src/app/shared/services/api/dto/create-certificate-profile-request-dto';

function isProfilelistUrl(url: string): boolean {
  return url === '/profilelist' || url.startsWith('/profilelist?');
}

export const {
  feature: profilelistFeature,
  actions: ProfilelistDataActions,
  createEffects: createProfilelistDataEffects,
} = createGridDataFeature<'Profilelist Data', Profile>('Profilelist Data', {
  routeFilter: route => isProfilelistUrl(route.url),
});

export const {
  feature: profilelistDrilldownFeature,
  actions: ProfilelistDrilldownActions,
  createEffects: createProfilelistDrilldownEffects,
} = createDrilldownFeature<'Profilelist Drilldown'>('Profilelist Drilldown', {
  routeFilter: route => isProfilelistUrl(route.url),
});

export const {
  feature: profilelistEditFeature,
  actions: ProfilelistEditActions,
  createEffects: createProfilelistEditEffects,
} = createEditItemFeature<'Profilelist Edit', Profile, UpdateProfileRequestDto>(
  'Profilelist Edit',
  {
    routeFilter: route => isProfilelistUrl(route.url),
  },
);

export const {
  feature: profilelistCloneFeature,
  actions: ProfilelistCloneActions,
  createEffects: createProfilelistCloneEffects,
} = createEditItemFeature<
  'Profilelist Clone',
  void,
  CreateCertificateProfileRequestDto
>('Profilelist Clone', {
  routeFilter: route => isProfilelistUrl(route.url),
  queryParamsConfig: {
    edit: 'clone',
  },
});

const reload = createAction('Profilelist reload');

export const ProfilelistActions = {
  ...ProfilelistDataActions,
  ...ProfilelistDrilldownActions,
  ...ProfilelistEditActions,
  reload,
};

export const { selectGridData: selectProfilelistGridData } = profilelistFeature;
export const { selectDrilldownKey: selectProfilelistDrilldownKey } =
  profilelistDrilldownFeature;
export const { selectSaving, selectEditItemKey: selectProfilelistEditItemKey } =
  profilelistEditFeature;
export const profilelistFeatures = [
  profilelistFeature,
  profilelistDrilldownFeature,
];
